import React from 'react';
import Paper from '@material-ui/core/Paper';
import useStyles from '../HomePage/TicketList/styles';

export default function Tab(props) {
  const { children, selectedTab, index } = props;
  const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={selectedTab !== index}
      id={`app-bar-tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {selectedTab === index && (
        <Paper elevation={0} className={classes.paper}>
          {children}
        </Paper>
      )}{' '}
    </div>
  );
}
